// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employee-deductions",
  Create: "/pyr/employee-deductions",
  Update: "/pyr/employee-deductions",
};
